import { CountryCode } from './country-code.enum';
import { FacebookCountryCode } from './facebook-country-code-enum';

export const CountryList: Record<CountryCode, string> = {
    [CountryCode.AC]: 'Ascension Island',
    [CountryCode.AD]: 'Andorra',
    [CountryCode.AE]: 'United Arab Emirates',
    [CountryCode.AF]: 'Afghanistan',
    [CountryCode.AG]: 'Antigua and Barbuda',
    [CountryCode.AI]: 'Anguilla',
    [CountryCode.AL]: 'Albania',
    [CountryCode.AM]: 'Armenia',
    [CountryCode.AN]: 'Netherlands Antilles',
    [CountryCode.AO]: 'Angola',
    [CountryCode.AQ]: 'Antarctica',
    [CountryCode.AR]: 'Argentina',
    [CountryCode.AS]: 'American Samoa',
    [CountryCode.AT]: 'Austria',
    [CountryCode.AU]: 'Australia',
    [CountryCode.AW]: 'Aruba',
    [CountryCode.AX]: 'Aland Islands',
    [CountryCode.AZ]: 'Azerbaijan',
    [CountryCode.BA]: 'Bosnia and Herzegovina',
    [CountryCode.BB]: 'Barbados',
    [CountryCode.BD]: 'Bangladesh',
    [CountryCode.BE]: 'Belgium',
    [CountryCode.BF]: 'Burkina Faso',
    [CountryCode.BG]: 'Bulgaria',
    [CountryCode.BH]: 'Bahrain',
    [CountryCode.BI]: 'Burundi',
    [CountryCode.BJ]: 'Benin',
    [CountryCode.BL]: 'Saint Barthelemy',
    [CountryCode.BM]: 'Bermuda',
    [CountryCode.BN]: 'Brunei Darussalam',
    [CountryCode.BO]: 'Bolivia',
    [CountryCode.BQ]: 'Bonaire, Sint Eustatius and Saba',
    [CountryCode.BR]: 'Brazil',
    [CountryCode.BS]: 'Bahamas',
    [CountryCode.BT]: 'Bhutan',
    [CountryCode.BV]: 'Bouvet Island',
    [CountryCode.BW]: 'Botswana',
    [CountryCode.BY]: 'Belarus',
    [CountryCode.BZ]: 'Belize',
    [CountryCode.CA]: 'Canada',
    [CountryCode.CC]: 'Cocos Islands',
    [CountryCode.CD]: 'Democratic Republic of the Congo',
    [CountryCode.CF]: 'Central African Republic',
    [CountryCode.CG]: 'Republic of the Congo',
    [CountryCode.CH]: 'Switzerland',
    [CountryCode.CI]: 'Ivory Coast',
    [CountryCode.CK]: 'Cook Islands',
    [CountryCode.CL]: 'Chile',
    [CountryCode.CM]: 'Cameroon',
    [CountryCode.CN]: 'China',
    [CountryCode.CO]: 'Colombia',
    [CountryCode.CR]: 'Costa Rica',
    [CountryCode.CU]: 'Cuba',
    [CountryCode.CV]: 'Cape Verde',
    [CountryCode.CW]: 'Curacao',
    [CountryCode.CX]: 'Christmas Island',
    [CountryCode.CY]: 'Cyprus',
    [CountryCode.CZ]: 'Czech Republic',
    [CountryCode.DE]: 'Germany',
    [CountryCode.DJ]: 'Djibouti',
    [CountryCode.DK]: 'Denmark',
    [CountryCode.DM]: 'Dominica',
    [CountryCode.DO]: 'Dominican Republic',
    [CountryCode.DZ]: 'Algeria',
    [CountryCode.EC]: 'Ecuador',
    [CountryCode.EE]: 'Estonia',
    [CountryCode.EG]: 'Egypt',
    [CountryCode.EH]: 'Western Sahara',
    [CountryCode.ER]: 'Eritrea',
    [CountryCode.ES]: 'Spain',
    [CountryCode.ET]: 'Ethiopia',
    [CountryCode.FI]: 'Finland',
    [CountryCode.FJ]: 'Fiji',
    [CountryCode.FK]: 'Falkland Islands',
    [CountryCode.FM]: 'Micronesia',
    [CountryCode.FO]: 'Faroe Islands',
    [CountryCode.FR]: 'France',
    [CountryCode.GA]: 'Gabon',
    [CountryCode.GB]: 'United Kingdom',
    [CountryCode.GD]: 'Grenada',
    [CountryCode.GE]: 'Georgia',
    [CountryCode.GF]: 'French Guiana',
    [CountryCode.GG]: 'Guernsey',
    [CountryCode.GH]: 'Ghana',
    [CountryCode.GI]: 'Gibraltar',
    [CountryCode.GL]: 'Greenland',
    [CountryCode.GM]: 'Gambia',
    [CountryCode.GN]: 'Guinea',
    [CountryCode.GP]: 'Guadeloupe',
    [CountryCode.GQ]: 'Equatorial Guinea',
    [CountryCode.GR]: 'Greece',
    [CountryCode.GS]: 'South Georgia and the South Sandwich Islands',
    [CountryCode.GT]: 'Guatemala',
    [CountryCode.GU]: 'Guam',
    [CountryCode.GW]: 'Guinea-Bissau',
    [CountryCode.GY]: 'Guyana',
    [CountryCode.HK]: 'Hong Kong',
    [CountryCode.HM]: 'Heard Island and McDonald Islands',
    [CountryCode.HN]: 'Honduras',
    [CountryCode.HR]: 'Croatia',
    [CountryCode.HT]: 'Haiti',
    [CountryCode.HU]: 'Hungary',
    [CountryCode.ID]: 'Indonesia',
    [CountryCode.IE]: 'Ireland',
    [CountryCode.IL]: 'Israel',
    [CountryCode.IM]: 'Isle of Man',
    [CountryCode.IN]: 'India',
    [CountryCode.IO]: 'British Indian Ocean Territory',
    [CountryCode.IQ]: 'Iraq',
    [CountryCode.IR]: 'Iran',
    [CountryCode.IS]: 'Iceland',
    [CountryCode.IT]: 'Italy',
    [CountryCode.JE]: 'Jersey',
    [CountryCode.JM]: 'Jamaica',
    [CountryCode.JO]: 'Jordan',
    [CountryCode.JP]: 'Japan',
    [CountryCode.KE]: 'Kenya',
    [CountryCode.KG]: 'Kyrgyzstan',
    [CountryCode.KH]: 'Cambodia',
    [CountryCode.KI]: 'Kiribati',
    [CountryCode.KM]: 'Comoros',
    [CountryCode.KN]: 'Saint Kitts and Nevis',
    [CountryCode.KP]: 'North Korea',
    [CountryCode.KR]: 'South Korea',
    [CountryCode.KW]: 'Kuwait',
    [CountryCode.KY]: 'Cayman Islands',
    [CountryCode.KZ]: 'Kazakhstan',
    [CountryCode.LA]: 'Laos',
    [CountryCode.LB]: 'Lebanon',
    [CountryCode.LC]: 'Saint Lucia',
    [CountryCode.LI]: 'Liechtenstein',
    [CountryCode.LK]: 'Sri Lanka',
    [CountryCode.LR]: 'Liberia',
    [CountryCode.LS]: 'Lesotho',
    [CountryCode.LT]: 'Lithuania',
    [CountryCode.LU]: 'Luxembourg',
    [CountryCode.LV]: 'Latvia',
    [CountryCode.LY]: 'Libya',
    [CountryCode.MA]: 'Morocco',
    [CountryCode.MC]: 'Monaco',
    [CountryCode.MD]: 'Moldova',
    [CountryCode.ME]: 'Montenegro',
    [CountryCode.MF]: 'Saint Martin',
    [CountryCode.MG]: 'Madagascar',
    [CountryCode.MH]: 'Marshall Islands',
    [CountryCode.MK]: 'Macedonia',
    [CountryCode.ML]: 'Mali',
    [CountryCode.MM]: 'Myanmar',
    [CountryCode.MN]: 'Mongolia',
    [CountryCode.MO]: 'Macao',
    [CountryCode.MP]: 'Northern Mariana Islands',
    [CountryCode.MQ]: 'Martinique',
    [CountryCode.MR]: 'Mauritania',
    [CountryCode.MS]: 'Montserrat',
    [CountryCode.MT]: 'Malta',
    [CountryCode.MU]: 'Mauritius',
    [CountryCode.MV]: 'Maldives',
    [CountryCode.MW]: 'Malawi',
    [CountryCode.MX]: 'Mexico',
    [CountryCode.MY]: 'Malaysia',
    [CountryCode.MZ]: 'Mozambique',
    [CountryCode.NA]: 'Namibia',
    [CountryCode.NC]: 'New Caledonia',
    [CountryCode.NE]: 'Niger',
    [CountryCode.NF]: 'Norfolk Island',
    [CountryCode.NG]: 'Nigeria',
    [CountryCode.NI]: 'Nicaragua',
    [CountryCode.NL]: 'Netherlands',
    [CountryCode.NO]: 'Norway',
    [CountryCode.NP]: 'Nepal',
    [CountryCode.NR]: 'Nauru',
    [CountryCode.NU]: 'Niue',
    [CountryCode.NZ]: 'New Zealand',
    [CountryCode.OM]: 'Oman',
    [CountryCode.PA]: 'Panama',
    [CountryCode.PE]: 'Peru',
    [CountryCode.PF]: 'French Polynesia',
    [CountryCode.PG]: 'Papua New Guinea',
    [CountryCode.PH]: 'Philippines',
    [CountryCode.PK]: 'Pakistan',
    [CountryCode.PL]: 'Poland',
    [CountryCode.PM]: 'Saint Pierre and Miquelon',
    [CountryCode.PN]: 'Pitcairn',
    [CountryCode.PR]: 'Puerto Rico',
    [CountryCode.PS]: 'Palestinian Territory',
    [CountryCode.PT]: 'Portugal',
    [CountryCode.PW]: 'Palau',
    [CountryCode.PY]: 'Paraguay',
    [CountryCode.QA]: 'Qatar',
    [CountryCode.RE]: 'Reunion',
    [CountryCode.RO]: 'Romania',
    [CountryCode.RS]: 'Serbia',
    [CountryCode.RU]: 'Russia',
    [CountryCode.RW]: 'Rwanda',
    [CountryCode.SA]: 'Saudi Arabia',
    [CountryCode.SB]: 'Solomon Islands',
    [CountryCode.SC]: 'Seychelles',
    [CountryCode.SD]: 'Sudan',
    [CountryCode.SE]: 'Sweden',
    [CountryCode.SG]: 'Singapore',
    [CountryCode.SH]: 'Saint Helena',
    [CountryCode.SI]: 'Slovenia',
    [CountryCode.SJ]: 'Svalbard and Jan Mayen',
    [CountryCode.SK]: 'Slovakia',
    [CountryCode.SL]: 'Sierra Leone',
    [CountryCode.SM]: 'San Marino',
    [CountryCode.SN]: 'Senegal',
    [CountryCode.SO]: 'Somalia',
    [CountryCode.SR]: 'Suriname',
    [CountryCode.SS]: 'South Sudan',
    [CountryCode.ST]: 'Sao Tome and Principe',
    [CountryCode.SV]: 'El Salvador',
    [CountryCode.SX]: 'Sint Maarten',
    [CountryCode.SY]: 'Syria',
    [CountryCode.SZ]: 'Swaziland',
    [CountryCode.TA]: 'Tristan da Cunha',
    [CountryCode.TC]: 'Turks and Caicos Islands',
    [CountryCode.TD]: 'Chad',
    [CountryCode.TF]: 'French Southern Territories',
    [CountryCode.TG]: 'Togo',
    [CountryCode.TH]: 'Thailand',
    [CountryCode.TJ]: 'Tajikistan',
    [CountryCode.TK]: 'Tokelau',
    [CountryCode.TL]: 'East Timor',
    [CountryCode.TM]: 'Turkmenistan',
    [CountryCode.TN]: 'Tunisia',
    [CountryCode.TO]: 'Tonga',
    [CountryCode.TR]: 'Turkey',
    [CountryCode.TT]: 'Trinidad and Tobago',
    [CountryCode.TV]: 'Tuvalu',
    [CountryCode.TW]: 'Taiwan',
    [CountryCode.TZ]: 'Tanzania',
    [CountryCode.UA]: 'Ukraine',
    [CountryCode.UG]: 'Uganda',
    [CountryCode.UM]: 'United States Minor Outlying Islands',
    [CountryCode.US]: 'United States',
    [CountryCode.UY]: 'Uruguay',
    [CountryCode.UZ]: 'Uzbekistan',
    [CountryCode.VA]: 'Vatican',
    [CountryCode.VC]: 'Saint Vincent and the Grenadines',
    [CountryCode.VE]: 'Venezuela',
    [CountryCode.VG]: 'British Virgin Islands',
    [CountryCode.VI]: 'U.S. Virgin Islands',
    [CountryCode.VN]: 'Vietnam',
    [CountryCode.VU]: 'Vanuatu',
    [CountryCode.WF]: 'Wallis and Futuna',
    [CountryCode.WS]: 'Samoa',
    [CountryCode.XK]: 'Kosovo',
    [CountryCode.YE]: 'Yemen',
    [CountryCode.YT]: 'Mayotte',
    [CountryCode.ZA]: 'South Africa',
    [CountryCode.ZM]: 'Zambia',
    [CountryCode.ZW]: 'Zimbabwe',
};

export const FacebookCountryList: Record<FacebookCountryCode, string> = {
    [FacebookCountryCode.AD]: 'Andorra',
    [FacebookCountryCode.AE]: 'United Arab Emirates',
    [FacebookCountryCode.AF]: 'Afghanistan',
    [FacebookCountryCode.AG]: 'Antigua and Barbuda',
    [FacebookCountryCode.AI]: 'Anguilla',
    [FacebookCountryCode.AL]: 'Albania',
    [FacebookCountryCode.AM]: 'Armenia',
    [FacebookCountryCode.AN]: 'Netherlands Antilles',
    [FacebookCountryCode.AO]: 'Angola',
    [FacebookCountryCode.AQ]: 'Antarctica',
    [FacebookCountryCode.AR]: 'Argentina',
    [FacebookCountryCode.AS]: 'American Samoa',
    [FacebookCountryCode.AT]: 'Austria',
    [FacebookCountryCode.AU]: 'Australia',
    [FacebookCountryCode.AW]: 'Aruba',
    [FacebookCountryCode.AX]: 'Aland Islands',
    [FacebookCountryCode.AZ]: 'Azerbaijan',
    [FacebookCountryCode.BA]: 'Bosnia and Herzegovina',
    [FacebookCountryCode.BB]: 'Barbados',
    [FacebookCountryCode.BD]: 'Bangladesh',
    [FacebookCountryCode.BE]: 'Belgium',
    [FacebookCountryCode.BF]: 'Burkina Faso',
    [FacebookCountryCode.BG]: 'Bulgaria',
    [FacebookCountryCode.BH]: 'Bahrain',
    [FacebookCountryCode.BI]: 'Burundi',
    [FacebookCountryCode.BJ]: 'Benin',
    [FacebookCountryCode.BL]: 'Saint Barthelemy',
    [FacebookCountryCode.BM]: 'Bermuda',
    [FacebookCountryCode.BN]: 'Brunei Darussalam',
    [FacebookCountryCode.BO]: 'Bolivia',
    [FacebookCountryCode.BQ]: 'Bonaire, Sint Eustatius and Saba',
    [FacebookCountryCode.BR]: 'Brazil',
    [FacebookCountryCode.BS]: 'Bahamas',
    [FacebookCountryCode.BT]: 'Bhutan',
    [FacebookCountryCode.BV]: 'Bouvet Island',
    [FacebookCountryCode.BW]: 'Botswana',
    [FacebookCountryCode.BY]: 'Belarus',
    [FacebookCountryCode.BZ]: 'Belize',
    [FacebookCountryCode.CA]: 'Canada',
    [FacebookCountryCode.CC]: 'Cocos Islands',
    [FacebookCountryCode.CD]: 'Democratic Republic of the Congo',
    [FacebookCountryCode.CF]: 'Central African Republic',
    [FacebookCountryCode.CG]: 'Republic of the Congo',
    [FacebookCountryCode.CH]: 'Switzerland',
    [FacebookCountryCode.CI]: 'Ivory Coast',
    [FacebookCountryCode.CK]: 'Cook Islands',
    [FacebookCountryCode.CL]: 'Chile',
    [FacebookCountryCode.CM]: 'Cameroon',
    [FacebookCountryCode.CN]: 'China',
    [FacebookCountryCode.CO]: 'Colombia',
    [FacebookCountryCode.CR]: 'Costa Rica',
    [FacebookCountryCode.CV]: 'Cape Verde',
    [FacebookCountryCode.CW]: 'Curacao',
    [FacebookCountryCode.CX]: 'Christmas Island',
    [FacebookCountryCode.CY]: 'Cyprus',
    [FacebookCountryCode.CZ]: 'Czech Republic',
    [FacebookCountryCode.DE]: 'Germany',
    [FacebookCountryCode.DJ]: 'Djibouti',
    [FacebookCountryCode.DK]: 'Denmark',
    [FacebookCountryCode.DM]: 'Dominica',
    [FacebookCountryCode.DO]: 'Dominican Republic',
    [FacebookCountryCode.DZ]: 'Algeria',
    [FacebookCountryCode.EC]: 'Ecuador',
    [FacebookCountryCode.EE]: 'Estonia',
    [FacebookCountryCode.EG]: 'Egypt',
    [FacebookCountryCode.EH]: 'Western Sahara',
    [FacebookCountryCode.ER]: 'Eritrea',
    [FacebookCountryCode.ES]: 'Spain',
    [FacebookCountryCode.ET]: 'Ethiopia',
    [FacebookCountryCode.FI]: 'Finland',
    [FacebookCountryCode.FJ]: 'Fiji',
    [FacebookCountryCode.FK]: 'Falkland Islands',
    [FacebookCountryCode.FM]: 'Micronesia',
    [FacebookCountryCode.FO]: 'Faroe Islands',
    [FacebookCountryCode.FR]: 'France',
    [FacebookCountryCode.GA]: 'Gabon',
    [FacebookCountryCode.GB]: 'United Kingdom',
    [FacebookCountryCode.GD]: 'Grenada',
    [FacebookCountryCode.GE]: 'Georgia',
    [FacebookCountryCode.GF]: 'French Guiana',
    [FacebookCountryCode.GG]: 'Guernsey',
    [FacebookCountryCode.GH]: 'Ghana',
    [FacebookCountryCode.GI]: 'Gibraltar',
    [FacebookCountryCode.GL]: 'Greenland',
    [FacebookCountryCode.GM]: 'Gambia',
    [FacebookCountryCode.GN]: 'Guinea',
    [FacebookCountryCode.GP]: 'Guadeloupe',
    [FacebookCountryCode.GQ]: 'Equatorial Guinea',
    [FacebookCountryCode.GR]: 'Greece',
    [FacebookCountryCode.GS]: 'South Georgia and the South Sandwich Islands',
    [FacebookCountryCode.GT]: 'Guatemala',
    [FacebookCountryCode.GU]: 'Guam',
    [FacebookCountryCode.GW]: 'Guinea-Bissau',
    [FacebookCountryCode.GY]: 'Guyana',
    [FacebookCountryCode.HK]: 'Hong Kong',
    [FacebookCountryCode.HM]: 'Heard Island and McDonald Islands',
    [FacebookCountryCode.HN]: 'Honduras',
    [FacebookCountryCode.HR]: 'Croatia',
    [FacebookCountryCode.HT]: 'Haiti',
    [FacebookCountryCode.HU]: 'Hungary',
    [FacebookCountryCode.ID]: 'Indonesia',
    [FacebookCountryCode.IE]: 'Ireland',
    [FacebookCountryCode.IL]: 'Israel',
    [FacebookCountryCode.IM]: 'Isle of Man',
    [FacebookCountryCode.IN]: 'India',
    [FacebookCountryCode.IO]: 'British Indian Ocean Territory',
    [FacebookCountryCode.IQ]: 'Iraq',
    [FacebookCountryCode.IS]: 'Iceland',
    [FacebookCountryCode.IT]: 'Italy',
    [FacebookCountryCode.JE]: 'Jersey',
    [FacebookCountryCode.JM]: 'Jamaica',
    [FacebookCountryCode.JO]: 'Jordan',
    [FacebookCountryCode.JP]: 'Japan',
    [FacebookCountryCode.KE]: 'Kenya',
    [FacebookCountryCode.KG]: 'Kyrgyzstan',
    [FacebookCountryCode.KH]: 'Cambodia',
    [FacebookCountryCode.KI]: 'Kiribati',
    [FacebookCountryCode.KM]: 'Comoros',
    [FacebookCountryCode.KN]: 'Saint Kitts and Nevis',
    [FacebookCountryCode.KR]: 'South Korea',
    [FacebookCountryCode.KW]: 'Kuwait',
    [FacebookCountryCode.KY]: 'Cayman Islands',
    [FacebookCountryCode.KZ]: 'Kazakhstan',
    [FacebookCountryCode.LA]: 'Laos',
    [FacebookCountryCode.LB]: 'Lebanon',
    [FacebookCountryCode.LC]: 'Saint Lucia',
    [FacebookCountryCode.LI]: 'Liechtenstein',
    [FacebookCountryCode.LK]: 'Sri Lanka',
    [FacebookCountryCode.LR]: 'Liberia',
    [FacebookCountryCode.LS]: 'Lesotho',
    [FacebookCountryCode.LT]: 'Lithuania',
    [FacebookCountryCode.LU]: 'Luxembourg',
    [FacebookCountryCode.LV]: 'Latvia',
    [FacebookCountryCode.LY]: 'Libya',
    [FacebookCountryCode.MA]: 'Morocco',
    [FacebookCountryCode.MC]: 'Monaco',
    [FacebookCountryCode.MD]: 'Moldova',
    [FacebookCountryCode.ME]: 'Montenegro',
    [FacebookCountryCode.MF]: 'Saint Martin',
    [FacebookCountryCode.MG]: 'Madagascar',
    [FacebookCountryCode.MH]: 'Marshall Islands',
    [FacebookCountryCode.MK]: 'Macedonia',
    [FacebookCountryCode.ML]: 'Mali',
    [FacebookCountryCode.MM]: 'Myanmar',
    [FacebookCountryCode.MN]: 'Mongolia',
    [FacebookCountryCode.MO]: 'Macao',
    [FacebookCountryCode.MP]: 'Northern Mariana Islands',
    [FacebookCountryCode.MQ]: 'Martinique',
    [FacebookCountryCode.MR]: 'Mauritania',
    [FacebookCountryCode.MS]: 'Montserrat',
    [FacebookCountryCode.MT]: 'Malta',
    [FacebookCountryCode.MU]: 'Mauritius',
    [FacebookCountryCode.MV]: 'Maldives',
    [FacebookCountryCode.MW]: 'Malawi',
    [FacebookCountryCode.MX]: 'Mexico',
    [FacebookCountryCode.MY]: 'Malaysia',
    [FacebookCountryCode.MZ]: 'Mozambique',
    [FacebookCountryCode.NA]: 'Namibia',
    [FacebookCountryCode.NC]: 'New Caledonia',
    [FacebookCountryCode.NE]: 'Niger',
    [FacebookCountryCode.NF]: 'Norfolk Island',
    [FacebookCountryCode.NG]: 'Nigeria',
    [FacebookCountryCode.NI]: 'Nicaragua',
    [FacebookCountryCode.NL]: 'Netherlands',
    [FacebookCountryCode.NO]: 'Norway',
    [FacebookCountryCode.NP]: 'Nepal',
    [FacebookCountryCode.NR]: 'Nauru',
    [FacebookCountryCode.NU]: 'Niue',
    [FacebookCountryCode.NZ]: 'New Zealand',
    [FacebookCountryCode.OM]: 'Oman',
    [FacebookCountryCode.PA]: 'Panama',
    [FacebookCountryCode.PE]: 'Peru',
    [FacebookCountryCode.PF]: 'French Polynesia',
    [FacebookCountryCode.PG]: 'Papua New Guinea',
    [FacebookCountryCode.PH]: 'Philippines',
    [FacebookCountryCode.PK]: 'Pakistan',
    [FacebookCountryCode.PL]: 'Poland',
    [FacebookCountryCode.PM]: 'Saint Pierre and Miquelon',
    [FacebookCountryCode.PN]: 'Pitcairn',
    [FacebookCountryCode.PR]: 'Puerto Rico',
    [FacebookCountryCode.PS]: 'Palestinian Territory',
    [FacebookCountryCode.PT]: 'Portugal',
    [FacebookCountryCode.PW]: 'Palau',
    [FacebookCountryCode.PY]: 'Paraguay',
    [FacebookCountryCode.QA]: 'Qatar',
    [FacebookCountryCode.RE]: 'Reunion',
    [FacebookCountryCode.RO]: 'Romania',
    [FacebookCountryCode.RS]: 'Serbia',
    [FacebookCountryCode.RU]: 'Russia',
    [FacebookCountryCode.RW]: 'Rwanda',
    [FacebookCountryCode.SA]: 'Saudi Arabia',
    [FacebookCountryCode.SB]: 'Solomon Islands',
    [FacebookCountryCode.SC]: 'Seychelles',
    [FacebookCountryCode.SE]: 'Sweden',
    [FacebookCountryCode.SG]: 'Singapore',
    [FacebookCountryCode.SH]: 'Saint Helena',
    [FacebookCountryCode.SI]: 'Slovenia',
    [FacebookCountryCode.SJ]: 'Svalbard and Jan Mayen',
    [FacebookCountryCode.SK]: 'Slovakia',
    [FacebookCountryCode.SL]: 'Sierra Leone',
    [FacebookCountryCode.SM]: 'San Marino',
    [FacebookCountryCode.SN]: 'Senegal',
    [FacebookCountryCode.SO]: 'Somalia',
    [FacebookCountryCode.SR]: 'Suriname',
    [FacebookCountryCode.SS]: 'South Sudan',
    [FacebookCountryCode.ST]: 'Sao Tome and Principe',
    [FacebookCountryCode.SV]: 'El Salvador',
    [FacebookCountryCode.SX]: 'Sint Maarten',
    [FacebookCountryCode.SZ]: 'Swaziland',
    [FacebookCountryCode.TC]: 'Turks and Caicos Islands',
    [FacebookCountryCode.TD]: 'Chad',
    [FacebookCountryCode.TF]: 'French Southern Territories',
    [FacebookCountryCode.TG]: 'Togo',
    [FacebookCountryCode.TH]: 'Thailand',
    [FacebookCountryCode.TJ]: 'Tajikistan',
    [FacebookCountryCode.TK]: 'Tokelau',
    [FacebookCountryCode.TL]: 'East Timor',
    [FacebookCountryCode.TM]: 'Turkmenistan',
    [FacebookCountryCode.TN]: 'Tunisia',
    [FacebookCountryCode.TO]: 'Tonga',
    [FacebookCountryCode.TR]: 'Turkey',
    [FacebookCountryCode.TT]: 'Trinidad and Tobago',
    [FacebookCountryCode.TV]: 'Tuvalu',
    [FacebookCountryCode.TW]: 'Taiwan',
    [FacebookCountryCode.TZ]: 'Tanzania',
    [FacebookCountryCode.UA]: 'Ukraine',
    [FacebookCountryCode.UG]: 'Uganda',
    [FacebookCountryCode.UM]: 'United States Minor Outlying Islands',
    [FacebookCountryCode.US]: 'United States',
    [FacebookCountryCode.UY]: 'Uruguay',
    [FacebookCountryCode.UZ]: 'Uzbekistan',
    [FacebookCountryCode.VA]: 'Vatican',
    [FacebookCountryCode.VC]: 'Saint Vincent and the Grenadines',
    [FacebookCountryCode.VE]: 'Venezuela',
    [FacebookCountryCode.VG]: 'British Virgin Islands',
    [FacebookCountryCode.VI]: 'U.S. Virgin Islands',
    [FacebookCountryCode.VN]: 'Vietnam',
    [FacebookCountryCode.VU]: 'Vanuatu',
    [FacebookCountryCode.WF]: 'Wallis and Futuna',
    [FacebookCountryCode.WS]: 'Samoa',
    [FacebookCountryCode.XK]: 'Kosovo',
    [FacebookCountryCode.YE]: 'Yemen',
    [FacebookCountryCode.YT]: 'Mayotte',
    [FacebookCountryCode.ZA]: 'South Africa',
    [FacebookCountryCode.ZM]: 'Zambia',
    [FacebookCountryCode.ZW]: 'Zimbabwe',
};

export const getCountryCodeByCountryName = (countryName: string): CountryCode | null => {
    const countryEntry = Object.entries(CountryList).find(([code, name]) => name === countryName) as
        [CountryCode, string] | undefined;
    if (countryEntry) return countryEntry[0];
    return null;
};
